<template>
  <div>
    <Breadcrumb :breadcrumb="breadcrumb" />
    <div class="wrap max-width">
      <div class="white-bg">
        <div class="title">{{ data ? data.title : '' }}</div>
        <div class="title-sub">
          <div class="fawen-unit">{{ data.originOrg }}</div>
          <div v-if="data.isCollect" class="collect-name" style="cursor: pointer" @click="unCollect">
            <img class="star-img" :src="require('@/assets/images/星星-active.png')" alt="" @click.stop="unCollect" />
            取消收藏
          </div>
          <div v-else class="collect-name" style="cursor: pointer" @click="collect">
            <img class="star-img" :src="require('@/assets/images/星星.png')" alt="" @click.stop="collect" />
            加入收藏
          </div>
        </div>
        <el-descriptions class="margin-top" :column="2" border labelClassName="label-class" contentClassName="content-class">
          <el-descriptions-item label="政策对象" :span="2">{{ data ? data.policyObject : '' }}</el-descriptions-item>
          <el-descriptions-item label="政策申报时间" :span="2">
            {{ data.title === '青年人才租房补贴' ? '每月21日～月底' : data.applyTimeType !== 1 ? data.applyTm : '常态受理' }}
            {{ data.applyTimeType == 3 ? '(以具体通知为准)' : '' }}
          </el-descriptions-item>
          <el-descriptions-item label="受理单位"> {{ data ? data.acceptOrg : '' }} </el-descriptions-item>
          <el-descriptions-item label="咨询电话"> {{ data ? data.acceptPhone : '' }} </el-descriptions-item>
          <el-descriptions-item label="政策依据" :span="2"> {{ data ? data.policyBasis : '' }} </el-descriptions-item>
          <el-descriptions-item label="政策内容" :span="2"> <div v-html="data.cont" /> </el-descriptions-item>
          <el-descriptions-item label="兑现途径" :span="2">
            <div v-if="data.redemptionTime" class="dxItem">
              <div class="dxItem1">
                {{ data.redemptionTime }}
              </div>
            </div>
            <div v-if="data.redemptionWay" class="dxItem">
              <div :class="data.redemptionTime ? 'dxItem2' : 'dxItem1'">
                {{ data.redemptionWay }}
              </div>
            </div>
            <div v-if="data.redemptionType" class="dxItem">
              <div :class="data.redemptionTime || data.redemptionWay ? 'dxItem2' : 'dxItem1'">
                {{ data.redemptionType }}
              </div>
            </div>
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
export default {
  name: 'PolicyDetail',
  components: { Breadcrumb },
  beforeRouteEnter(to, from, next) {
    console.log('to===', to.name)
    console.log('from.name ===', from.name)
    console.log('from ===', from)
    const type = to.query.type || 'person'
    next((vm) => {
      if (from.name === '政策查询') {
        // 处理语句，可以是 data 中的数据，也可以是 methods中的函数。vm 相当于 this
        vm.breadcrumb = [
          {
            path: '/',
            name: '首页',
            meta: {
              title: '首页',
            },
          },
          {
            path: '/policy-inquiries',
            name: '政策月历',
            meta: {
              title: '政策月历',
            },
          },
          {
            path: '/policy-detail/:id',
            name: '政策详情',
            meta: {
              title: '政策详情',
            },
          },
        ]
      } else if (from.name === '我的收藏') {
        vm.breadcrumb = [
          {
            path: '/',
            name: '首页',
            meta: {
              title: '首页',
            },
          },
          {
            path: '/user/myCollection',
            name: '政策收藏',
            meta: {
              title: '政策收藏',
            },
          },
          {
            path: '/policy-detail/:id',
            name: '政策详情',
            meta: {
              title: '政策详情',
            },
          },
        ]
      } else {
        vm.breadcrumb = [
          {
            path: '/',
            name: '首页',
            meta: {
              title: '首页',
            },
          },
          {
            path: `/policy-inquiries/${type}`,
            name: '政策列表',
            meta: {
              title: '政策列表',
            },
          },
          {
            path: '/policy-detail/:id',
            name: '政策详情',
            meta: {
              title: '政策详情',
            },
          },
        ]
      }
    })
  },
  data() {
    return {
      data: {},
      breadcrumb: [],
    }
  },
  computed: {
    isLogin() {
      return this.$store.getters.isLogin
      // return true
    },
  },
  mounted() {
    this.getDetails()
  },
  methods: {
    unCollect() {
      this.$http({ method: 'get', url: `/zzmh/in/api/policy/unCollect?id=` + this.data.id })
        .then((res) => {
          this.$message.success('操作成功')
          this.getDetails()
        })
        .catch(() => {})
    },
    collect() {
      this.$http({ method: 'get', url: `/zzmh/in/api/policy/collect?id=` + this.data.id })
        .then((res) => {
          this.$message.success('操作成功')
          this.getDetails()
        })
        .catch(() => {})
    },
    getDetails() {
      let api = '/zzmh/api/policy/info/'
      this.$http({ method: 'get', url: api + this.$route.params.id }).then((res) => {
        if (res.code === 0) {
          console.log(res)
          this.data = { ...res.data.zzmhPolicyVo, isCollect: res.data.isCollect }
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
@media screen {
  .wrap {
    .white-bg {
      background: #fff;
      padding: 30px 70px;
    }
    .title {
      font-family: PingFangSC-Semibold;
      font-size: 24px;
      color: rgba(51, 51, 51, 0.85);
      text-align: center;
      line-height: 24px;
      font-weight: 600;
    }
    .title-sub {
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #8c8c8c;
      text-align: center;
      font-weight: 400;
      display: flex;
      justify-content: center;
      margin-bottom: 15px;
      align-items: center;
      margin: 16px 0;
      .star-img {
        width: 24px;
      }
      .collect-name {
        display: flex;
        align-items: center;
      }
    }
    .fawen-unit {
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #8c8c8c;
      text-align: center;
      font-weight: 400;
      margin-right: 20px;
    }
    /deep/.el-descriptions {
      .label-class {
        width: 200px;
        font-family: PingFangSC-Semibold;
        font-size: 18px;
        color: rgba(51, 51, 51, 0.85);
        text-align: center;
        font-weight: 600;
        padding: 20px 12px;
      }
      .content-class {
        font-family: PingFangSC-Regular;
        font-size: 18px;
        color: rgba(51, 51, 51, 0.85);
        font-weight: 400;
        padding: 20px 12px;
        p {
          margin: 0;
          line-height: 1.8;
        }
      }
    }
    h2 {
      text-align: center;
      color: #000;
      margin-top: 2.0833vw;
    }
    p {
      margin: 2.0833vw 0;
      color: rgba(0, 0, 0, 0.45);
      text-align: center;
    }
    .table {
      border: 1px solid #000;
      p {
        margin: 0;
        border: 1px solid #000;
        padding: 2.0833vw;
        display: flex;
        span {
          text-align: left;
        }
      }
      .contItem {
        display: flex;
        color: rgba(0, 0, 0, 0.45);
        margin: 0;
        border: 1px solid #000;
        padding: 2.0833vw;
        display: flex;
        /deep/ p {
          margin: 0;
        }
      }
    }
    .dxbox {
      margin: 0;
      border: 1px solid #000;
      padding: 2.0833vw;
      display: flex;
      flex-wrap: wrap;
    }
    .dxItem {
      font-size: 18px;
      color: rgba(51, 51, 51, 0.85);
      font-weight: 400;
      width: 100%;
      display: flex;
      justify-content: center;
    }
    .dxItem1 {
      max-width: 50%;
      padding: 5px 10px;
      background: rgba(40, 85, 241, 0.1);
      border: 1.5px dashed rgba(40, 85, 241, 1);
      border-radius: 7px;
    }
    .dxItem2 {
      max-width: 50%;
      margin-top: 60px;
      padding: 5px 10px;
      background: rgba(40, 85, 241, 0.1);
      border: 1.5px dashed rgba(40, 85, 241, 1);
      border-radius: 7px;
      position: relative;
      display: flex;
      justify-content: center;
    }
    .dxItem2::before {
      content: '';
      width: 50px;
      height: 50px;
      background-image: url('../../assets/images/路径.png');
      background-repeat: no-repeat;
      background-size: auto 100%;
      background-position: center;
      position: absolute;
      top: -55px;
    }
  }
  @media (min-width: 769px) {
  }

  @media (max-width: 768px) {
  }
}
</style>
